import { Select } from '@/components/common/Select'
import { ATTRIBUTION_VIEWS, type AttributionView } from '@/types/analytics'

interface Props {
  value: AttributionView
  onChange: (view: AttributionView) => void
  disabled?: boolean
  /** Unique id so the inline label's htmlFor resolves when several selectors share a page. */
  id?: string
  /** Hide the visible "Attribution" label (kept for screen readers) — e.g. when the host
   *  already provides an "Attribution" heading and the inline label would be redundant. */
  hideLabel?: boolean
}

/**
 * Toolbar selector that flips the active attribution view (ORB-373). Built on the common
 * `Select`; controlled via value/onChange so the host can refetch analytics when it changes.
 */
export function AttributionViewSelect({ value, onChange, disabled, id = 'attributionView', hideLabel = false }: Props) {
  return (
    <div className="flex items-center gap-2">
      <label htmlFor={id} className={hideLabel ? 'sr-only' : 'text-xs font-medium text-slate-600 dark:text-slate-300 whitespace-nowrap'}>
        Attribution
      </label>
      <Select
        name={id}
        options={ATTRIBUTION_VIEWS}
        value={value}
        disabled={disabled}
        placeholder=""
        onChange={(e: Event) => onChange((e.target as HTMLSelectElement).value as AttributionView)}
        className="py-1.5 text-sm"
        containerClassName="w-44"
      />
    </div>
  )
}
